import React, { useState } from 'react';
import slika11 from '../assets/slika11.png';
import slika12 from '../assets/slika12.png';
import AgentInfo from './AgentInfo';

const NasiAgenti = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const agenti = [
    {
      slika: slika11,
      ime: 'Tijana Milic',
      pozicija: 'Direktor',
      telefon: '062/123-456',
      email: 'tijana@example.com',
    },
    {
      slika: slika12,
      ime: 'Sofija Lazic',
      pozicija: 'Agent',
      telefon: '062/111-101',
      email: 'sofija@example.com',
    },
  ];

  return (
    <section id="nasi-agenti" className="relative w-full flex flex-col justify-center items-center bg-gray-800 min-h-[150vh] sm:min-h-[120vh] pb-28"> {/* Dodato pb-32 */}
      {/* Naslov sekcije sa animacijom pulsiranja */}
      <h2 className="text-4xl font-bold text-pink-600 mb-16 z-20 relative">Naši Agenti</h2>

      {/* SVG zakrivljena linija na vrhu */}
      <div className="absolute top-0 w-full z-10">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1440 200"
          className="w-full"
          preserveAspectRatio="none"
          style={{ marginTop: '-10px' }}
        >
          <path
            fill="#1F2937" // Tamna pozadina
            d="M0,160L80,140C160,120,320,100,480,100C640,100,800,120,960,130C1120,140,1280,150,1360,160L1440,170L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"
          ></path>
        </svg>
      </div>

      {/* Plavi deo ispod SVG-a */}
      <div className="absolute top-[150px] w-full bg-gray-800 h-[500px] sm:h-[300px] z-0"></div>

      {/* Sadržaj agenti */}
      <div className="relative z-10 grid grid-cols-1 sm:grid-cols-2 gap-[110px] w-full px-8 sm:gap-[70px]">
        {agenti.map((agent, index) => (
          <div key={index} className="flex flex-col justify-center items-center relative mb-16 sm:mb-12">
            <div
              className="relative group w-60 h-60 sm:w-72 sm:h-72 rounded-full border-4 border-pink-600 shadow-lg overflow-hidden"
              style={{ marginTop: '-10px' }} // Pomeranje ka gore za 1 cm
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              {/* Hover Background unutar kruga */}
              <div className="absolute inset-0 rounded-full bg-pink-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-0"></div>
              
              {/* Slika agenta */}
              <img
                src={agent.slika}
                alt={`Agent ${index + 1}`}
                className="w-full h-full object-cover rounded-full z-10 relative"
              />

              {/* Efekat sjaja */}
              <div className="absolute inset-0 rounded-full border-4 border-transparent group-hover:border-pink-600 group-hover:shadow-[0_0_20px_5px_rgba(225,0,85,1)] transition-all duration-300 z-0"></div>
            </div>

            {/* Prikazivanje AgentInfo samo ako je hoveredIndex jednak trenutnom indeksu */}
            <AgentInfo
              ime={agent.ime}
              pozicija={agent.pozicija}
              telefon={agent.telefon}
              email={agent.email}
              isVisible={hoveredIndex === index}
            />
          </div>
        ))}
      </div>
    </section>
  );
};

export default NasiAgenti;
